import { Component, OnInit } from '@angular/core';
import { PaymentService } from '../../../../services/payment.service';
import { HelpersService } from '../../../../services/helpers.service';
import { BroadcastService } from '../../../../services/broadcast.service';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ConfirmationService, MenuItem } from 'primeng/api';
import moment from 'moment';

@Component({
  selector: 'app-manage-subscriptions',
  templateUrl: './manage-subscriptions.component.html',
  styleUrls: ['./manage-subscriptions.component.scss'],
  providers: [MessageService],
})
export class ManageSubscriptionsComponent implements OnInit {
  public workshopPlans: any = [];
  public rentalPlans: any = [];
  public addonPlans: any = [];
  public currencies: any = [];
  public loadingPlans: boolean = false;
  public loadingStripePricing: boolean = false;
  public countryData: any = {};
  public selectedWorkshopPlan: any = null;
  public selectedRentalPlan: any = null;
  public selectedWhatsappPlan: any = null;
  public packageDiscountAmount: number = 30;
  public showSubscriptionPayment: boolean = false;
  public paymentData: any = null;
  public currentSubscription: any = {};
  public hasActiveSubscription: boolean = false;
  public editSubscription: boolean = false;
  public busyUpdating: boolean = false;
  public displayCancellationReason = false;
  public cancellationReason: string = '';
  public busyCancelling: boolean = false;

  public stripePortalURL: string = null;
  public stripeCustomerID: string = null;
  public stripeProductID: string = null;
  public stripeSubscriptionID: string = null;
  public subscription;
  any = null;

  public workshopFeatures: any = [
    this.translate.instant(
      'bikeshop.manage_subscription.workshop_features.feature_1',
    ),
    this.translate.instant(
      'bikeshop.manage_subscription.workshop_features.feature_2',
    ),
    this.translate.instant(
      'bikeshop.manage_subscription.workshop_features.feature_3',
    ),
    this.translate.instant(
      'bikeshop.manage_subscription.workshop_features.feature_4',
    ),
    this.translate.instant(
      'bikeshop.manage_subscription.workshop_features.feature_5',
    ),
    this.translate.instant(
      'bikeshop.manage_subscription.workshop_features.feature_6',
    ),
    this.translate.instant(
      'bikeshop.manage_subscription.workshop_features.feature_7',
    ),
    this.translate.instant(
      'bikeshop.manage_subscription.workshop_features.feature_8',
    ),
    this.translate.instant(
      'bikeshop.manage_subscription.workshop_features.feature_9',
    ),
    this.translate.instant(
      'bikeshop.manage_subscription.workshop_features.feature_10',
    ),
    this.translate.instant(
      'bikeshop.manage_subscription.workshop_features.feature_11',
    ),
  ];
  public rentalFeatures: any = [
    this.translate.instant(
      'bikeshop.manage_subscription.rental_features.feature_1',
    ),
    this.translate.instant(
      'bikeshop.manage_subscription.rental_features.feature_2',
    ),
    this.translate.instant(
      'bikeshop.manage_subscription.rental_features.feature_3',
    ),
    this.translate.instant(
      'bikeshop.manage_subscription.rental_features.feature_4',
    ),
    this.translate.instant(
      'bikeshop.manage_subscription.rental_features.feature_5',
    ),
    this.translate.instant(
      'bikeshop.manage_subscription.rental_features.feature_6',
    ),
    this.translate.instant(
      'bikeshop.manage_subscription.rental_features.feature_7',
    ),
  ];

  public whatsappFeatures: any = [
    this.translate.instant('bikeshop.manage_subscription.whatsapp_features.feature_1'),
    this.translate.instant('bikeshop.manage_subscription.whatsapp_features.feature_2'),
    this.translate.instant('bikeshop.manage_subscription.whatsapp_features.feature_3'),
    this.translate.instant('bikeshop.manage_subscription.whatsapp_features.feature_4')
  ];

  constructor(
    private paymentService: PaymentService,
    private helpersService: HelpersService,
    private translate: TranslateService,
    private messageService: MessageService,
    private broadcastService: BroadcastService,
    private confirmationService: ConfirmationService,
  ) { }

  ngOnInit() {
    document.documentElement.style.setProperty('--show-intercom', 'none');
    this.countryData = this.helpersService.getCountryData();
    this.getCurrentSubscription();
    this.getSubscriptionProducts();
  }

  ngOnDestroy() {
    document.documentElement.style.setProperty('--show-intercom', 'inherit');
  }

  getCurrentSubscription() {
    this.paymentService
      .getCurrentStoreSubscription(this.helpersService.getPartnerId())
      .subscribe((subscription: any) => {
        this.currentSubscription = subscription;
        this.hasActiveSubscription =
          subscription.subscription &&
          subscription.subscription.subscriptionID &&
          subscription.subscription.subscriptionID.indexOf('sub_') > -1;
        if (
          this.currentSubscription.subscribedWorkshopPlan &&
          this.currentSubscription.subscribedWorkshopPlan &&
          this.currentSubscription.subscribedWorkshopPlan.portalIdentifier
        ) {
          this.selectedWorkshopPlan =
            this.currentSubscription.subscribedWorkshopPlan.portalIdentifier;
        }
        if (
          this.currentSubscription.subscribedRentalPlan &&
          this.currentSubscription.subscribedRentalPlan &&
          this.currentSubscription.subscribedRentalPlan.portalIdentifier
        ) {
          this.selectedRentalPlan =
            this.currentSubscription.subscribedRentalPlan.portalIdentifier;
        }
        if (
          this.currentSubscription.whatsappSubscription &&
          this.currentSubscription.whatsappSubscription.portalIdentifier
        ) {
          this.selectedWhatsappPlan =
            this.currentSubscription.whatsappSubscription.portalIdentifier;
        }
        if (this.hasActiveSubscription) {
          this.getPortalSessionInfo();
        }
      });
  }

  getPortalSessionInfo() {
    this.paymentService
      .getStripePortalSession(
        this.helpersService.getPartnerId(),
        window.location.href,
      )
      .subscribe((res) => {
        if (res.portalSession && res.portalSession.url) {
          this.stripePortalURL = res.portalSession.url;
          this.stripeCustomerID = res.stripeCustomerID;
          this.stripeProductID = res.stripeProductID;
          this.stripeSubscriptionID = res.stripeSubscriptionID;
          this.subscription = res.subscription;
        }
      });
  }

  getSubscriptionProducts() {
    this.loadingPlans = true;
    this.paymentService
      .getSubscriptionProducts(this.helpersService.getPartnerId())
      .subscribe((result: any) => {
        this.workshopPlans = result.workshopPlans;
        this.rentalPlans = result.rentalPlans;
        this.addonPlans = result.addOns;
        this.currencies = result.currencies;
        this.setPlanInformation(this.workshopPlans);
        this.setPlanInformation(this.rentalPlans);
        this.setPlanInformation(this.addonPlans);
        this.getPackagesStripe();
        this.loadingPlans = false;
      });
  }

  getPackagesStripe() {
    this.loadingStripePricing = true;
    this.paymentService.getPackagesStripe().subscribe((stripeProducts: any) => {
      this.loadingStripePricing = false;

      this.setPlanPricing(this.workshopPlans, stripeProducts);
      this.setPlanPricing(this.rentalPlans, stripeProducts);
      this.setPlanPricing(this.addonPlans, stripeProducts);
    });
  }

  isProductSelected() {
    return this.selectedRentalPlan || this.selectedWorkshopPlan;
  }

  getCurrencySymbol(currency: string) {
    var country = this.currencies
      .filter((x: any) => {
        return x.currency.toLowerCase() === currency.toLowerCase();
      })
      .pop();
    if (country) {
      return country.currencySymbol;
    } else {
      return currency;
    }
  }

  setPlanInformation(plans: any) {
    plans.forEach((plan: any) => {
      switch (plan.portalIdentifier) {
        case 'WORKSHOP_TRIAL':
          plan.title = 'Free Trial';
          break;
        case 'WORKSHOP_LITE':
          plan.title = 'Lite';
          plan.technicians = '1';
          plan.SMS = 100;
          break;
        case 'WORKSHOP_PRO':
          plan.title = 'Professional';
          plan.technicians = '2-4';
          plan.SMS = 250;
          break;
        case 'WORKSHOP_PREMIUM':
          plan.title = 'Premium';
          plan.technicians = '5+';
          plan.SMS = 350;
          break;
        case 'RENTAL_TRIAL':
          plan.title = 'Free Trial';
          break;
        case 'RENTAL_LITE':
          plan.title = 'Lite';
          plan.rentalItems = '1-20';
          break;
        case 'RENTAL_STANDARD':
          plan.title = 'Standard';
          plan.rentalItems = '21-50';
          break;
        case 'RENTAL_PRO':
          plan.title = 'Professional';
          plan.rentalItems = '51-100';
          break;
        case 'RENTAL_PREMIUM':
          plan.title = 'Premium';
          plan.rentalItems = '101-200';
          break;
        case 'RENTAL_ENTERPRISE':
            plan.title = 'Enterprise';
            plan.rentalItems = '200+';
            break;
        case 'WHATSAPP':
          plan.title = 'Whatsapp';
          break;
      }
    });
  }

  setPlanPricing(plans: any, stripeProducts: any) {
    plans.forEach((plan: any) => {
      var stripeProduct = stripeProducts
        .filter((x: any) => {
          return x.id === plan.stripeProductID;
        })
        .pop();
      if (stripeProduct) {
        //Find the pricing that matches the stores country
        if (stripeProduct.pricing) {
          var pricing = stripeProduct.pricing
            .filter((x: any) => {
              return (
                x.currency.toLowerCase() ===
                this.countryData.currency.toLowerCase()
              );
            })
            .pop();
          if (pricing) {
            plan.pricing = pricing;
          } else {
            //If currency soes not exist, default to the only currency is only one option exists, else look for the US prising
            if (stripeProduct.pricing.length === 1) {
              plan.pricing = stripeProduct.pricing[0];
            } else {
              var pricing = stripeProduct.pricing
                .filter((x: any) => {
                  return x.currency.toLowerCase() === 'usd';
                })
                .pop();
              if (pricing) {
                plan.pricing = pricing;
              }
            }
          }
        }
      }
    });
  }

  selectWorkshopPlan(plan) {
    if (
      this.loadingStripePricing ||
      (this.hasActiveSubscription && !this.editSubscription)
    )
      return;

    if (plan.portalIdentifier === this.selectedWorkshopPlan) {
      this.selectedWorkshopPlan = null;
    } else {
      this.selectedWorkshopPlan = plan.portalIdentifier;
    }
  }

  selectRentalPlan(plan) {
    if (
      this.loadingStripePricing ||
      (this.hasActiveSubscription && !this.editSubscription)
    )
      return;

    if (plan.portalIdentifier === this.selectedRentalPlan) {
      this.selectedRentalPlan = null;
    } else {
      this.selectedRentalPlan = plan.portalIdentifier;
    }
  }

  selectAddOnPlan(plan) {
    if (
      this.loadingStripePricing ||
      (this.hasActiveSubscription && !this.editSubscription)
    )
      return;
    switch (plan.portalIdentifier) {
      case "WHATSAPP":
        if (plan.portalIdentifier === this.selectedWhatsappPlan) {
          this.selectedWhatsappPlan = null;
        } else {
          this.selectedWhatsappPlan = plan.portalIdentifier;
        }
        break;
    }
  }

  addOnSelected(plan) {
    if (plan.portalIdentifier === "WHATSAPP" && this.selectedWhatsappPlan === plan.portalIdentifier) {
      return true;
    } else {
      false;
    }
  }

  getSummary() {
    if (
      this.selectedWorkshopPlan === 'WORKSHOP_TRIAL' ||
      this.selectedRentalPlan === 'RENTAL_TRIAL'
    )
      return '';

    var workshopPlan = this.workshopPlans
      .filter((x: any) => {
        return x.portalIdentifier === this.selectedWorkshopPlan;
      })
      .pop();
    var rentalPlan = this.rentalPlans
      .filter((x: any) => {
        return x.portalIdentifier === this.selectedRentalPlan;
      })
      .pop();
    var whatsappPlan = this.addonPlans
      .filter((x: any) => {
        return x.portalIdentifier === this.selectedWhatsappPlan;
      })
      .pop();

    if (
      workshopPlan &&
      workshopPlan.pricing &&
      rentalPlan &&
      rentalPlan.pricing &&
      whatsappPlan &&
      whatsappPlan.pricing
    ) {
      if (workshopPlan.pricing.amount >= rentalPlan.pricing.amount) {
        return this.translate.instant(
          'bikeshop.manage_subscription.summary_rental_discount_with_whatsapp',
          {
            currencySymbol: this.getCurrencySymbol(
              workshopPlan.pricing.currency,
            ),
            discountAmount: this.packageDiscountAmount,
            workshopAmount: (workshopPlan.pricing.amount / 100).toFixed(0),
            rentalAmount: (rentalPlan.pricing.amount / 100).toFixed(0),
            whatsappAmount: (whatsappPlan.pricing.amount / 100).toFixed(0),
            discountedAmount: (
              workshopPlan.pricing.amount / 100 +
              this.getDiscountedAmount(rentalPlan) +
              whatsappPlan.pricing.amount / 100
            ).toFixed(2),
          },
        );
      } else {
        return this.translate.instant(
          'bikeshop.manage_subscription.summary_workshop_discount_with_whatsapp',
          {
            currencySymbol: this.getCurrencySymbol(
              workshopPlan.pricing.currency,
            ),
            discountAmount: this.packageDiscountAmount,
            workshopAmount: (workshopPlan.pricing.amount / 100).toFixed(0),
            rentalAmount: (rentalPlan.pricing.amount / 100).toFixed(0),
            whatsappAmount: (whatsappPlan.pricing.amount / 100).toFixed(0),
            discountedAmount: (
              rentalPlan.pricing.amount / 100 +
              this.getDiscountedAmount(workshopPlan) +
              whatsappPlan.pricing.amount / 100
            ).toFixed(2),
          },
        );
      }
    } else if (
      workshopPlan &&
      workshopPlan.pricing &&
      rentalPlan &&
      rentalPlan.pricing
    ) {
      if (workshopPlan.pricing.amount >= rentalPlan.pricing.amount) {
        return this.translate.instant(
          'bikeshop.manage_subscription.summary_rental_discount',
          {
            currencySymbol: this.getCurrencySymbol(
              workshopPlan.pricing.currency,
            ),
            discountAmount: this.packageDiscountAmount,
            workshopAmount: (workshopPlan.pricing.amount / 100).toFixed(0),
            rentalAmount: (rentalPlan.pricing.amount / 100).toFixed(0),
            discountedAmount: (
              workshopPlan.pricing.amount / 100 +
              this.getDiscountedAmount(rentalPlan)
            ).toFixed(2),
          },
        );
      } else {
        return this.translate.instant(
          'bikeshop.manage_subscription.summary_workshop_discount',
          {
            currencySymbol: this.getCurrencySymbol(
              workshopPlan.pricing.currency,
            ),
            discountAmount: this.packageDiscountAmount,
            workshopAmount: (workshopPlan.pricing.amount / 100).toFixed(0),
            rentalAmount: (rentalPlan.pricing.amount / 100).toFixed(0),
            discountedAmount: (
              rentalPlan.pricing.amount / 100 +
              this.getDiscountedAmount(workshopPlan)
            ).toFixed(2),
          },
        );
      }
    }
  }

  getWorkshopOnlySummary() {
    if (this.selectedWorkshopPlan === 'WORKSHOP_TRIAL') return '';

    var workshopPlan = this.workshopPlans
      .filter((x: any) => {
        return x.portalIdentifier === this.selectedWorkshopPlan;
      })
      .pop();

    var whatsappPlan = this.addonPlans
      .filter((x: any) => {
        return x.portalIdentifier === this.selectedWhatsappPlan;
      })
      .pop();

    if (workshopPlan && workshopPlan.pricing && whatsappPlan && whatsappPlan.pricing) {
      return this.translate.instant(
        'bikeshop.manage_subscription.summary_workshop_with_whatsapp',
        {
          currencySymbol: this.getCurrencySymbol(workshopPlan.pricing.currency),
          workshopAmount: (workshopPlan.pricing.amount / 100).toFixed(0),
          whatsappAmount: (whatsappPlan.pricing.amount / 100).toFixed(0),
          totalAmount: ((workshopPlan.pricing.amount / 100) + (whatsappPlan.pricing.amount / 100)).toFixed(2)
        },
      );
    } else if (workshopPlan && workshopPlan.pricing) {
      return this.translate.instant(
        'bikeshop.manage_subscription.summary_workshop_only',
        {
          currencySymbol: this.getCurrencySymbol(workshopPlan.pricing.currency),
          workshopAmount: (workshopPlan.pricing.amount / 100).toFixed(0)
        },
      );
    } else {
      return '';
    }
  }

  getRentalOnlySummary() {
    if (this.selectedRentalPlan === 'RENTAL_TRIAL') return '';

    var rentalPlan = this.rentalPlans
      .filter((x: any) => {
        return x.portalIdentifier === this.selectedRentalPlan;
      })
      .pop();

    var whatsappPlan = this.addonPlans
      .filter((x: any) => {
        return x.portalIdentifier === this.selectedWhatsappPlan;
      })
      .pop();

    if (rentalPlan && rentalPlan.pricing && whatsappPlan && whatsappPlan.pricing) {
      return this.translate.instant(
        'bikeshop.manage_subscription.summary_rental_with_whatsapp',
        {
          currencySymbol: this.getCurrencySymbol(rentalPlan.pricing.currency),
          rentalAmount: (rentalPlan.pricing.amount / 100).toFixed(0),
          whatsappAmount: (whatsappPlan.pricing.amount / 100).toFixed(0),
          totalAmount: ((rentalPlan.pricing.amount / 100) + (whatsappPlan.pricing.amount / 100)).toFixed(2)
        },
      );
    } else if (rentalPlan && rentalPlan.pricing) {
      return this.translate.instant(
        'bikeshop.manage_subscription.summary_rental_only',
        {
          currencySymbol: this.getCurrencySymbol(rentalPlan.pricing.currency),
          rentalAmount: (rentalPlan.pricing.amount / 100).toFixed(0),
        },
      );
    } else {
      return '';
    }
  }

  getDiscountedAmount(plan) {
    return (
      (plan.pricing.amount -
        plan.pricing.amount * (this.packageDiscountAmount / 100)) /
      100
    );
  }

  isWorkshopDiscounted() {
    if (
      this.selectedWorkshopPlan === 'WORKSHOP_TRIAL' ||
      this.selectedRentalPlan === 'RENTAL_TRIAL'
    )
      return false;
    var workshopPlan = this.workshopPlans
      .filter((x: any) => {
        return x.portalIdentifier === this.selectedWorkshopPlan;
      })
      .pop();
    var rentalPlan = this.rentalPlans
      .filter((x: any) => {
        return x.portalIdentifier === this.selectedRentalPlan;
      })
      .pop();
    if (workshopPlan && rentalPlan) {
      if (workshopPlan.pricing.amount >= rentalPlan.pricing.amount) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  isRentalDiscounted() {
    if (
      this.selectedWorkshopPlan === 'WORKSHOP_TRIAL' ||
      this.selectedRentalPlan === 'RENTAL_TRIAL'
    )
      return false;
    var workshopPlan = this.workshopPlans
      .filter((x: any) => {
        return x.portalIdentifier === this.selectedWorkshopPlan;
      })
      .pop();
    var rentalPlan = this.rentalPlans
      .filter((x: any) => {
        return x.portalIdentifier === this.selectedRentalPlan;
      })
      .pop();
    if (workshopPlan && rentalPlan) {
      if (workshopPlan.pricing.amount >= rentalPlan.pricing.amount) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  createSubscription() {
    const data = {
      partnerID: this.helpersService.getPartnerId(),
      partnerName: this.helpersService.getPartnerData().Name,
      accountEmail: this.helpersService.getPartnerData().eMail,
      additionalEmail: this.helpersService.getProfileData().eMail,
      customerStripeID: null,
      stripeSubscriptionID: null,
      packageDiscountAmount: this.packageDiscountAmount,
      workshopPackage: this.workshopPlans
        .filter((x) => {
          return x.portalIdentifier === this.selectedWorkshopPlan;
        })
        .pop(),
      rentalPackage: this.rentalPlans
        .filter((x) => {
          return x.portalIdentifier === this.selectedRentalPlan;
        })
        .pop(),
      whatsappPackage: this.addonPlans
        .filter((x) => {
          return x.portalIdentifier === this.selectedWhatsappPlan;
        })
        .pop(),
    };

    if (data.workshopPackage && data.workshopPackage.pricing) {
      data.workshopPackage.pricing.currencySymbol = this.getCurrencySymbol(
        data.workshopPackage.pricing.currency,
      );
      if (this.isWorkshopDiscounted()) {
        data.workshopPackage.pricing.price = this.getDiscountedAmount(
          data.workshopPackage,
        );
      } else {
        data.workshopPackage.pricing.price =
          data.workshopPackage.pricing.amount / 100;
      }
    }
    if (data.rentalPackage && data.rentalPackage.pricing) {
      data.rentalPackage.pricing.currencySymbol = this.getCurrencySymbol(
        data.rentalPackage.pricing.currency,
      );
      if (this.isRentalDiscounted()) {
        data.rentalPackage.pricing.price = this.getDiscountedAmount(
          data.rentalPackage,
        );
      } else {
        data.rentalPackage.pricing.price =
          data.rentalPackage.pricing.amount / 100;
      }
    }
    console.log(data.whatsappPackage)
    if (data.whatsappPackage && data.whatsappPackage.pricing) {
      data.whatsappPackage.pricing.currencySymbol = this.getCurrencySymbol(data.whatsappPackage.pricing.currency);
      data.whatsappPackage.pricing.price = data.whatsappPackage.pricing.amount / 100;
    }
    console.log(data.whatsappPackage)

    this.handlePayment(data);
  }

  updateSubscriptionConfirm() {
    this.confirmationService.confirm({
      key: 'update_subscription_confirmation',
      rejectLabel: this.translate.instant('general.no'),
      acceptLabel: this.translate.instant('general.yes'),
      header: this.translate.instant(
        'bikeshop.manage_subscription.update_subscription',
      ),
      message:
        this.hasActiveSubscription &&
          (this.selectedWorkshopPlan === 'WORKSHOP_TRIAL' ||
            this.selectedRentalPlan === 'RENTAL_TRIAL')
          ? this.translate.instant(
            'bikeshop.manage_subscription.free_trial_added',
          )
          : this.translate.instant(
            'bikeshop.manage_subscription.subscription_update_confirmation',
            {
              updateSubscriptionSummary:
                this.selectedWorkshopPlan && this.selectedRentalPlan
                  ? this.getSummary()
                  : this.selectedWorkshopPlan && !this.selectedRentalPlan
                    ? this.getWorkshopOnlySummary()
                    : this.selectedRentalPlan && !this.selectedWorkshopPlan
                      ? this.getRentalOnlySummary()
                      : '',
            },
          ),
      accept: () => {
        this.updateSubscription();
      },
    });
  }

  updateSubscription() {
    const data = {
      partnerID: this.helpersService.getPartnerId(),
      partnerName: this.helpersService.getPartnerData().Name,
      accountEmail: this.helpersService.getPartnerData().eMail,
      additionalEmail: this.helpersService.getProfileData().eMail,
      customerStripeID: this.currentSubscription.stripeCustomerID,
      stripeSubscriptionID: this.currentSubscription.subscriptionID,
      packageDiscountAmount: this.packageDiscountAmount,
      workshopPackage: this.workshopPlans
        .filter((x) => {
          return x.portalIdentifier === this.selectedWorkshopPlan;
        })
        .pop(),
      rentalPackage: this.rentalPlans
        .filter((x) => {
          return x.portalIdentifier === this.selectedRentalPlan;
        })
        .pop(),
      whatsappPackage: this.addonPlans
        .filter((x) => {
          return x.portalIdentifier === this.selectedWhatsappPlan;
        })
        .pop()
    };
    this.busyUpdating = true;
    this.paymentService.updateStripeSubscription(data).subscribe(
      (subscription: any) => {
        if (!subscription.error) {
          this.editSubscription = false;
          this.getCurrentSubscription();
          this.messageService.add({
            life: 3000,
            closable: false,
            detail: this.translate.instant(
              'bikeshop.manage_subscription.subscription_updated',
            ),
          });
          this.broadcastService.sendMessage({ payment: true });
        }
        this.busyUpdating = false;
      },
      (err) => {
        this.busyUpdating = false;
      },
    );
  }

  cancelStripeSubscription() {
    this.displayCancellationReason = false;
    this.busyCancelling = true;

    const data = {
      reason: this.cancellationReason,
    };
    this.paymentService
      .cancelStripeSubscription(this.helpersService.getPartnerId(), data)
      .subscribe(
        (res: any) => {
          if (!res.error) {
            this.editSubscription = false;
            this.busyCancelling = false;
            this.getCurrentSubscription();
            this.messageService.add({
              life: 3000,
              closable: false,
              detail: this.translate.instant(
                'bikeshop.manage_subscription.subscription_cancelled',
              ),
            });
            this.broadcastService.sendMessage({ payment: true });
          } else {
            this.messageService.add({
              life: 3000,
              closable: false,
              detail: res.error,
            });
            this.busyCancelling = false;
          }
        },
        (err) => {
          this.busyCancelling = false;
        },
      );
  }

  handlePayment(data: any) {
    this.paymentData = data;
    this.showSubscriptionPayment = true;
  }

  isTrialOnly() {
    return (
      (this.selectedWorkshopPlan &&
        this.selectedWorkshopPlan === 'WORKSHOP_TRIAL' &&
        this.selectedRentalPlan &&
        this.selectedRentalPlan === 'RENTAL_TRIAL') ||
      (this.selectedWorkshopPlan &&
        this.selectedWorkshopPlan === 'WORKSHOP_TRIAL' &&
        !this.selectedRentalPlan) ||
      (!this.selectedWorkshopPlan &&
        this.selectedRentalPlan &&
        this.selectedRentalPlan === 'RENTAL_TRIAL')
    );
  }

  createTrial() {
    const data = {
      partnerID: this.helpersService.getPartnerId(),
      partnerName: this.helpersService.getPartnerData().Name,
      workshopPackage: this.workshopPlans
        .filter((x) => {
          return x.portalIdentifier === this.selectedWorkshopPlan;
        })
        .pop(),
      rentalPackage: this.rentalPlans
        .filter((x) => {
          return x.portalIdentifier === this.selectedRentalPlan;
        })
        .pop(),
    };

    this.busyUpdating = true;
    this.paymentService.createStripeSubscription(data).subscribe(
      (res) => {
        if (res.error) {
          this.busyUpdating = false;
        } else {
          this.getCurrentSubscription();
          this.busyUpdating = false;
          this.messageService.add({
            life: 3000,
            closable: false,
            detail: this.translate.instant(
              'bikeshop.manage_subscription.trial_updated',
            ),
          });
          this.broadcastService.sendMessage({ payment: true });
        }
      },
      (err) => {
        this.busyUpdating = false;
      },
    );
  }

  closeRentalProduct() {
    this.showSubscriptionPayment = false;
    this.getCurrentSubscription();
    this.broadcastService.sendMessage({ payment: true });
  }

  openStripePortal() {
    window.open(this.stripePortalURL, '_self');
  }

  setEditSubscription() {
    if (this.editSubscription) {
      if (
        this.currentSubscription.subscribedWorkshopPlan &&
        this.currentSubscription.subscribedWorkshopPlan &&
        this.currentSubscription.subscribedWorkshopPlan.portalIdentifier
      ) {
        this.selectedWorkshopPlan =
          this.currentSubscription.subscribedWorkshopPlan.portalIdentifier;
      }
      if (
        this.currentSubscription.subscribedRentalPlan &&
        this.currentSubscription.subscribedRentalPlan &&
        this.currentSubscription.subscribedRentalPlan.portalIdentifier
      ) {
        this.selectedRentalPlan =
          this.currentSubscription.subscribedRentalPlan.portalIdentifier;
      }
      this.editSubscription = false;
    } else {
      this.editSubscription = true;
    }
  }

  hasSubscriptionChanged() {
    var currentWorkshopPlan =
      this.currentSubscription.subscribedWorkshopPlan &&
        this.currentSubscription.subscribedWorkshopPlan.portalIdentifier
        ? this.currentSubscription.subscribedWorkshopPlan.portalIdentifier
        : null;
    var currentRentalPlan =
      this.currentSubscription.subscribedRentalPlan &&
        this.currentSubscription.subscribedRentalPlan.portalIdentifier
        ? this.currentSubscription.subscribedRentalPlan.portalIdentifier
        : null;

    var currentWhatsappPlan =
      this.currentSubscription.whatsappSubscription &&
        this.currentSubscription.whatsappSubscription.portalIdentifier
        ? this.currentSubscription.whatsappSubscription.portalIdentifier
        : null;

    return (
      this.selectedRentalPlan !== currentRentalPlan ||
      this.selectedWorkshopPlan !== currentWorkshopPlan ||
      this.selectedWhatsappPlan !== currentWhatsappPlan
    );
  }
}
